<template>
  <div id="order-list" class="list">
    <div class="order-list-header list-header">
      <ul>
        <li>{{$_('date')}}</li>
        <li>{{$_('satab_number_order')}}</li>
        <li>{{$_('customer_order_reference')}}</li>
        <li>{{$_('amount')}}</li>
        <li>{{$_('status')}}</li>
        <li>{{$_('delivered_percentage')}}</li>
        <li>{{$_('still_to_deliver')}}</li>
        <li>{{$_('satab_departure_delay')}}</li>
      </ul>
    </div>
    <div class="order-list-body list-body" v-if="items.length > 0">
      <div v-for="(item, index) in items" :key="index">
        <OrderLine :dataline="item" />
      </div>
    </div>
     <div v-else>
      <div class="order-list-footer no-result">
        <span>{{$_('no_result')}}</span>
      </div>
    </div>
    <div class="pagination-container">
      <Pagination
        :nNumeroPage="pagination_info.nNumeroPage"
        :nNombreElementParPage="pagination_info.nNombreElementParPage"
        :nNbElementTotal="pagination_info.nNbRecordData"
        :sTypeElement="$_('orders')"
        :fn="vGetOrder"
      />
    </div>
  </div>
</template>

<script>
import OrderLine from "./OrderLine";
import Pagination from "@/common/components/widget/Pagination/Pagination";

import orderService from '../services/orderService';

export default {
  name: "OrderList",
  components: {
    OrderLine,
    Pagination
  },
  computed: {
    getResearch() {
      return this.$store.getters['commande/get_research']
    }
  },
  data() {
    return {
      items: [],
      pagination_info: {
        nNumeroPage: 1,
        nNombreElementParPage: 20,
        nNbRecordData: 0
      }
    };
  },
  created() {
    this.vGetOrder();
  },
  methods: {
    vGetOrder(nNumeroPage, nNombreElementParPage) {

      let poffset = 0;

      if (nNumeroPage > 0) {
        poffset = nNumeroPage * nNombreElementParPage;
      }

      if(this.$store.getters['commande/get_reset_order_list'] === true){
        this.items = [];
      }

      return orderService.getOrder({
        fref: this.$store.getters['commande/get_fref'] !== '' ? this.$store.getters['commande/get_fref'] : null,
        fncde: this.$store.getters['commande/get_fncde'] !== '' ? this.$store.getters['commande/get_fncde'] : null,
        fmod: this.$store.getters['commande/get_fmod']  !== '' ? this.$store.getters['commande/get_fmod'] : null,
        fcol: this.$store.getters['commande/get_fcol']  !== '' ? this.$store.getters['commande/get_fcol'] : null,
        fdate_cdemin: this.$store.getters['commande/get_fdatecdemin']  !== '' ? this.$store.getters['commande/get_fdatecdemin'] : null ,
        fdate_cdemax: this.$store.getters['commande/get_fdatecdemax']  !== '' ? this.$store.getters['commande/get_fdatecdemax'] : null,
        fstatut: this.$store.getters['commande/get_fstatut'] !== '' ? this.$store.getters['commande/get_fstatut'] : null,
        poffset,
        plimit: 20
      })
      .then( res => {

        this.pagination_info.nNbRecordData = res.data.NB_RECORD;

        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.items.push(obj);
          });   
        }
        this.$store.dispatch('commande/LAUNCH_RESEARCH', {launch: false});
        this.$store.dispatch('commande/SELECT', {key: 'reset_order_list', value: false});

        return this.pagination_info;

      }).catch( err => {
        console.error(err);
      });
    }
  },
  watch: {
    getResearch(value) {
      if(value === true) {
        this.vGetOrder();
      }
    }
  }
};
</script>

<style scoped>
#order-list {
  padding: 30px;
}
.order-list-header ul {
  display: flex;
}
.order-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 8);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.order-list-header {
  padding: 15px 0px;
}
.pagination-container {
  margin-top: 20px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px #e9e9e9;
  margin-bottom: 20px;
}
.no-result span {
  color: #8B8B8B;
}
</style>